<template>
    <b-modal v-model="modal_component.show"
             centered
             :title="action_component + ' Componente'"
             hide-header-close
             no-close-on-esc
             no-close-on-backdrop
             size="lg"
    >
        <form @submit.prevent="validateForm()"
              data-vv-scope="component_product"
        >
            <b-row class="mb-2">
                <b-col md="12">
                    <label for="name">Componente</label>
                    <b-row>
                        <b-col cols="11"
                               class="pr-0"
                        >
                            <el-select id="name"
                                       name="name"
                                       v-model="component_product.cal_component_id"
                                       size="small"
                                       filterable
                                       clearable
                                       no-data-text="No hay datos que coincidan"
                                       no-match-text="No hay datos que coincidan"
                                       data-vv-as=" "
                                       v-validate="'required'"
                            >
                                <el-option v-for="c in components"
                                           :key="c.id"
                                           :label="c.cas_number + ' - ' + c.name"
                                           :value="c.id"
                                />
                            </el-select>
                            <span class="text-danger small"
                                  v-text="errors.first('component_product.name')"
                            />
                        </b-col>
                        <b-col class="pl-0">
                            <b-button variant="primary"
                                      v-if="!component_product.cal_component_id"
                                      class="float-right"
                                      size="sm"
                                      @click="openModalComponentForCreation"
                            >
                                <i class="fa fa-plus"></i>
                            </b-button>

                            <b-button variant="primary"
                                      v-else
                                      class="float-right"
                                      size="sm"
                                      @click="openModalComponentForEdition"
                            >
                                <i class="fa fa-edit"></i>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <label for="reported_percentage">Porcentaje reportado</label>
                    <el-input id="reported_percentage"
                              name="reported_percentage"
                              size="small"
                              type="text"
                              v-model="component_product.reported_percentage"
                              data-vv-as=" "
                              v-validate="'required|decimal:4|min_value:0.001|max_value:100'"
                    />
                    <span class="text-danger small"
                          v-text="errors.first('component_product.reported_percentage')"
                    />
                </b-col>
                <b-col md="4">
                    <b-form-group>
                        <label for="omit_in_composition"
                               class="w-100"
                        >
                            &nbsp;
                        </label>
                        <b-form-checkbox v-model="component_product.omit_in_composition"
                                         :unchecked-value="0"
                                         :value="1"
                        >
                            Omitir en composición
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group>
                        <label for="omit_in_carcinogens"
                               class="w-100"
                        >
                            &nbsp;
                        </label>
                        <b-form-checkbox v-model="component_product.omit_in_carcinogens"
                                         :unchecked-value="0"
                                         :value="1"
                        >
                            Omitir de cancerígenos
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>

        </form>

        <template #modal-footer>
            <div class="w-100">
                <b-row>
                    <b-col cols="12"
                           class="text-center"
                    >
                        <b-button @click="validateForm"
                                  variant="primary"
                                  class="mr-1"
                                  size="sm"
                        >
                            <i class="fa fa-save"></i> Guardar
                        </b-button>
                        <b-button @click="closeModal"
                                  variant="secondary"
                                  class="ml-1"
                                  size="sm"
                        >
                            <i class="fa fa-close"></i> Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>

    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'component',
    computed: {
        ...mapState('calculator', [
            'modal_raw_material',
            'raw_material',
            'categories',
            'product',
            'component_product',
            'components',
            'action_raw_material',
            'raw_materials',
            'modal_component',
            'action_component'
        ])
    },
    created() {
        this.setPaginateFilter(false);
    },
    methods: {
        ...mapActions('calculator', [
            'getRawMaterial',
            'getManufacturers',
            'createRawMaterial',
            'createComponentProduct',
            'getRawMaterials',
            'updateComponents'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setPaginateFilter',
            'setModalComponentsShow',
            'setModalComponentShow',
            'setModalComponentShow',
            'setComponent',
            'setActionComponent',
            'resetComponent',
            'resetComponent',
            'addComponent',
            'setShowToModalWizard',
            'setCalProductIdToComponentProduct'
        ]),
        validateForm() {
            this.$validator.validateAll('component_product')
                .then(async (result) => {
                    if (result) {
                        this.setCalProductIdToComponentProduct(this.raw_material.cal_raw_material_id);
                        await this.createComponentProduct(this.component_product);
                        await this.getRawMaterial(this.raw_material);
                        this.closeModal();
                    }
                });
        },
        closeModal() {
            this.resetComponent();
            this.setModalComponentShow(false);
            this.setShowToModalWizard(true);
        },
        openModalComponentForCreation() {
            this.resetComponent();
            this.setActionComponent('Crear');
            this.setModalComponentShow(false);
            this.setModalComponentShow(true);
        },
        openModalComponentForEdition() {
            let component = this.components.find(c => c.id === this.component.pivot.cal_component_id);

            if (!component) {
                return;
            }

            this.setComponent(component);

            this.setActionComponent('Editar');
            this.setModalComponentShow(false);
            this.setModalComponentShow(true);
        }
    }
};
</script>

<style scoped>

</style>
